import styled, { css } from 'styled-components';
import { useAppDispatch, useAppSelector } from '@app/hooks';
import { toggleTheme } from '@features/theme/model/slice';
import { IconMoon, IconSun } from '@shared/ui/icons';

const Toggle = styled.button<{ $dark: boolean }>`
  position: relative;
  flex-shrink: 0;
  width: 48px;
  height: 28px;
  border-radius: ${({ theme }) => theme.radius.pill};
  background: ${({ theme, $dark }) => ($dark ? theme.colors.primary : theme.colors.surface)};
  border: 1px solid
    ${({ theme, $dark }) => ($dark ? theme.colors.primary : theme.colors.borderStrong)};
  cursor: pointer;
  padding: 0;
  transition:
    background ${({ theme }) => theme.motion.base} ${({ theme }) => theme.motion.easeOut},
    border-color ${({ theme }) => theme.motion.base} ${({ theme }) => theme.motion.easeOut};

  &:hover {
    border-color: ${({ theme }) => theme.colors.primaryHover};
  }
`;

/* Кружок-ползунок: едет вправо в тёмной теме, внутри — знак текущей темы
   (солнце или полумесяц) фирменным цветом. */
const Knob = styled.span<{ $dark: boolean }>`
  position: absolute;
  top: 2px;
  left: 2px;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.colors.primary};
  background: ${({ theme }) => theme.colors.backgroundElevated};
  box-shadow: ${({ theme }) => theme.shadow.sm};
  transition: transform ${({ theme }) => theme.motion.base} ${({ theme }) => theme.motion.spring};
  ${({ $dark }) =>
    $dark &&
    css`
      transform: translateX(20px);
    `}

  svg {
    display: block;
  }
`;

export function ThemeToggle() {
  const dispatch = useAppDispatch();
  const current = useAppSelector((s) => s.theme.current);
  const isDark = current === 'dark';
  return (
    <Toggle
      $dark={isDark}
      onClick={() => dispatch(toggleTheme())}
      aria-label={isDark ? 'Включить светлую тему' : 'Включить тёмную тему'}
      title={isDark ? 'Светлая тема' : 'Тёмная тема'}
    >
      <Knob $dark={isDark}>
        {isDark ? <IconMoon size={14} strokeWidth={2} /> : <IconSun size={14} strokeWidth={2} />}
      </Knob>
    </Toggle>
  );
}
